import { normalizePersian, toEnDigits } from '@/lib/format'

export const slugify = (value: string): string => {
    const cleaned = normalizePersian(toEnDigits(value))
        .toLowerCase()
        .replace(/[ً-ٰٟ]/g, '')
        .replace(/‌/g, '-')
        .replace(/[​‍﻿]/g, '')
        .replace(/[^a-z0-9ء-غف-يپچژکگی-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')

    return cleaned.slice(0, 80).replace(/-+$/g, '')
}

export const productHref = (slug: string): string => `/product/${encodeURIComponent(slug)}`

export const categoryHref = (slug: string): string => `/shop?category=${encodeURIComponent(slug)}`
